import React, { useState, useMemo, useEffect } from 'react'
import { sidebarItems } from '../config/sidebarItems'
import { useLocation } from 'react-router-dom'
import SidebarItemsList from '../components/sidebar/SidebarItemsList'
import SidebarHeader from '../components/sidebar/SidebarHeader'
import { isItemActive as checkIsItemActive, getOpenSubmenuIndex } from '../components/sidebar/sidebarUtils'
import { useAuth } from '../contexts/AuthContext'
import { filterMenuByPermissions } from '../utils/menuFilter'

export default function FullyExpandedSidebar() {
  const location = useLocation();
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const { hasPermission, isSuperAdmin, permissions } = useAuth();

  // Filter menu items based on permissions - memoized for performance
  const filteredMenuItems = useMemo(() => {
    return filterMenuByPermissions(sidebarItems, hasPermission, isSuperAdmin);
  }, [hasPermission, isSuperAdmin, permissions]);

  // Auto-open the submenu that contains the current path (e.g. /product-master/pre-ipo/inventory/14/update)
  useEffect(() => {
    const index = getOpenSubmenuIndex(filteredMenuItems, location.pathname);
    if (index !== null) setOpenSubmenu(index);
  }, [location.pathname, filteredMenuItems]);

  const isItemActive = (item) => {
    return checkIsItemActive(item, location.pathname);
  };

  const toggleSubmenu = (index) => {
    if (openSubmenu === index) {
      setOpenSubmenu(null);
    } else {
      setOpenSubmenu(index);
    }
  };

  return (
    <>
      <div className='w-64 h-full bg-surface overflow-y-auto hidden xl:block'>
      <div className="py-6">
        {/* Logo is hidden by default, set isVisible to true to show it */}
        <SidebarHeader isVisible={false} />

        <SidebarItemsList 
          items={filteredMenuItems} 
          openSubmenu={openSubmenu} 
          toggleSubmenu={toggleSubmenu}
          isItemActive={isItemActive}
          location={location}
        />
        
      </div>
    </div>
    </>
  
  );
}
